"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function debounce(functionToDebounce, timeout) {
    if (timeout === void 0) { timeout = 5; }
    var timer;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () { return functionToDebounce.apply(_this, args); }, timeout);
    };
}
exports.default = debounce;
//# sourceMappingURL=debounce.js.map